import { render, staticRenderFns } from "./snack.vue?vue&type=template&id=f741f0de&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "snack.vue"
export default component.exports